module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/138.dc3978b8.png";